import { readDisplayAddSearch } from '../../lib/search-display-intent.ts'
import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'
import { DisplayDetail } from './-components/display-detail.tsx'

/** A nested display URL uses the Displays page policy and adds no rail entry. */
export const Route = createFileRoute('/platform/displays_/$name')({
  validateSearch: readDisplayAddSearch,
  component: DisplayDetailPage
})
function DisplayDetailPage(): JSX.Element {
  const { name } = Route.useParams()
  const navigate = Route.useNavigate()
  const { addPage } = Route.useSearch()
  return (
    <DisplayDetail
      key={name}
      name={name}
      addPage={addPage}
      navigate={path => {
        void navigate({ href: path })
      }}
    />
  )
}
